import React from "react";
import { STYLE_PREFIX } from "../const";
import "./style.less";
var Drawer = function Drawer(_ref) {
  var isShow = _ref.isShow,
    onClose = _ref.onClose,
    children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(STYLE_PREFIX, "-custom-drawer")
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(STYLE_PREFIX, "-custom-drawer_content ").concat(isShow ? 'isShow' : '')
  }, children), isShow && /*#__PURE__*/React.createElement("div", {
    className: "".concat(STYLE_PREFIX, "-custom-drawer_overlay"),
    onClick: onClose
  }));
};
export default Drawer;